class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });
    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
        const selectedOptionLabel = document.querySelector('.radio-option__label.selected-value');
        const sortByLabelSpan = document.querySelector('.sort-by-label');
        if (selectedOptionLabel && sortByLabelSpan) {
          sortByLabelSpan.innerHTML = selectedOptionLabel.innerHTML.trim();
        }
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById('ProductGridContainer').innerHTML;

    document
      .getElementById('ProductGridContainer')
      .querySelectorAll('.scroll-trigger')
      .forEach((element) => {
        element.classList.add('scroll-trigger--cancel');
      });
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    const facetDetailsElements = parsedHTML.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
    };
    const facetsToRender = Array.from(facetDetailsElements).filter((element) => !matchesIndex(element));
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`).innerHTML = element.innerHTML;
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));

    // let pageParams = window.location.href;
    //         console.log(pageParams);
    //         if(pageParams.includes('sort_by')){
    //           console.log("Inside sort_by");
    //           pageParams = pageParams.replace("https://novora-clothing.myshopify.com/collections/moon-blue?sort_by=", '');
    //         }
    //       document.getElementById('selected-sort').innerHTML = `FILE AND SORT BY: ${pageParams}`;
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
      facetsIconChange();
      mobileFacetsRender();
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];
    mobileElementSelectors.forEach((selector) => {
      const htmlElement = html.querySelector(selector);
      const documentElement = document.querySelector(selector);

      if (htmlElement && documentElement) {
        documentElement.innerHTML = htmlElement.innerHTML;
      }
    });

    const menuDrawer = document.getElementById('FacetFiltersFormMobile')?.closest('menu-drawer');
    if (menuDrawer && typeof menuDrawer.bindEvents === 'function') {
      menuDrawer.bindEvents();
    }
  }


  static renderCounts(source, target) {
    const targetElement = target.querySelector('.facets__selected');
    const sourceElement = source.querySelector('.facets__selected');

    const targetElementAccessibility = target.querySelector('.facets__summary');
    const sourceElementAccessibility = source.querySelector('.facets__summary');

    if (sourceElement && targetElement) {
      target.querySelector('.facets__selected').outerHTML = source.querySelector('.facets__selected').outerHTML;
      facetsIconChange();
    }

    if (targetElementAccessibility && sourceElementAccessibility) {
      target.querySelector('.facets__summary').outerHTML = source.querySelector('.facets__summary').outerHTML;
      facetsIconChange();
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      },
    ];
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    if (event.srcElement.className == 'mobile-facets__checkbox') {
      const searchParams = this.createSearchParams(event.target.closest('form'));
      this.onSubmitForm(searchParams, event);
    } else {
      const forms = [];
      const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
            const noJsElements = document.querySelectorAll('.no-js-list');
            noJsElements.forEach((el) => el.remove());
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join('&'), event);

    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf('?') == -1
        ? ''
        : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input').forEach((element) =>
      element.addEventListener('change', this.onRangeChange.bind(this))
    );
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('min', 0);
    if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
    facetsIconChange();
  }
}

customElements.define('facet-remove', FacetRemove);

function facetsIconChange() {
  const facetsDetailsWrapper = document.querySelectorAll('.accordion-details-wrapper');
  facetsDetailsWrapper.forEach((details) => {
    const iconsPlusContainer = details.querySelector('.icon-plus-container');
    const iconsMinusContainer = details.querySelector('.icon-minus-container');

    function toggleIcons() {
      if (details.hasAttribute('open')) {
        iconsPlusContainer.classList.add('tw-hidden');
        iconsPlusContainer.classList.remove('tw-block');
        iconsMinusContainer.classList.add('tw-block');
        iconsMinusContainer.classList.remove('tw-hidden');
      } else {
        iconsPlusContainer.classList.add('tw-block');
        iconsPlusContainer.classList.remove('tw-hidden');
        iconsMinusContainer.classList.add('tw-hidden');
        iconsMinusContainer.classList.remove('tw-block');
      }
    }
    toggleIcons();
    details.addEventListener('toggle', toggleIcons);
  });
}
facetsIconChange();

const mobileDetailsWrapper = document.querySelectorAll('.accordion-details-wrapper');

class MobileFilters extends HTMLElement {
  constructor() {
    super();
    const mobileDetails = this.querySelectorAll('.accordion-details-wrapper');
    mobileDetails.forEach((detail) => {
      if (detail.classList.contains('mobile-details-wrapper')) {
        detail.addEventListener('toggle', () => {
          mobileFacetsRender(detail);
        });
      }
    })
  }
}
customElements.define('mobile-filters', MobileFilters);

function mobileFacetsRender(details) {
  if(details){
    if (details.classList.contains('mobile-details-wrapper')) {
      const summary = details.querySelector('summary');
      const mobileDetailsList = summary.querySelector('.mobile-facets__list');
      if (details.hasAttribute('open')) {
        mobileDetailsList.classList.remove('hidden');
        mobileDetailsList.classList.add('tw-flex');
        summary.style.borderBottom = '1px solid #808080';
      } else {
        mobileDetailsList.classList.add('hidden');
        mobileDetailsList.classList.remove('tw-flex');
        summary.style.borderBottom = 'none';
      }
    }
  }
  else{
    mobileDetailsWrapper.forEach((details) => {
      if (details.classList.contains('mobile-details-wrapper')) {
        const summary = details.querySelector('summary');
        const mobileDetailsList = summary.querySelector('.mobile-facets__list');
        if (details.hasAttribute('open')) {
          mobileDetailsList.classList.remove('hidden');
          mobileDetailsList.classList.add('tw-flex');
          summary.style.borderBottom = '1px solid #808080';
        } else {
          mobileDetailsList.classList.add('hidden');
          mobileDetailsList.classList.remove('tw-flex');
          summary.style.borderBottom = 'none';
        }
      }
    });
  }
}
mobileFacetsRender();

class ScrollToTopButton extends HTMLElement {
  constructor() {
      super();
      this.button = this.querySelector("#scrollToTopBtn");
      this.button.classList.add('tw-hidden');
      this.scrollFunction = this.scrollFunction.bind(this);
      this.scrollToTop = this.scrollToTop.bind(this);
  }

  connectedCallback() {
      window.addEventListener('scroll', this.scrollFunction);
      this.button.addEventListener('click', this.scrollToTop);
  }

  disconnectedCallback() {
      window.removeEventListener('scroll', this.scrollFunction);
      this.button.removeEventListener('click', this.scrollToTop);
  }

  scrollFunction() {
      if (document.body.scrollTop > 200 || document.documentElement.scrollTop > 200) {
          this.button.classList.remove('tw-hidden');
      } else {
          this.button.classList.add('tw-hidden');
      }
  }

  scrollToTop() {
      window.scrollTo({
          top: 0,
          behavior: 'smooth'
      });
  }
}

customElements.define('scroll-to-top-button', ScrollToTopButton);

class CollectionSubcategories extends HTMLElement {
  constructor() {
    super();
    this.currentCollectionUrl = window.location.pathname;
  }

  connectedCallback() {
    this.addEventListeners();
  }

  addEventListeners() {
    this.querySelectorAll('a').forEach(anchor => {
      anchor.addEventListener('click', event => {
        event.preventDefault();
        const url = new URL(anchor.getAttribute('data-collection-url'), window.location.origin);
        const collectionTitle = anchor.getAttribute('data-collection-title');
        // const searchParams = new URLSearchParams(window.location.search);
        // searchParams.forEach((value, key) => {
        //   url.searchParams.append(key, value);
        // });
        // Check if the URL has the "?page=1" parameter, and add it if not
        if (!url.searchParams.has('page')) {
          url.searchParams.append('page', '1');
        }
        this.updateSections(url.toString(), collectionTitle);
      });
    });
  }

  updateSections(url, collectionTitle) {
    const sectionsToUpdate = {
      productGrid: 'main-collection-product-grid',
      collectionBanner: 'main-collection-banner'
    };

    const promises = Object.keys(sectionsToUpdate).map(section => {
      console.log(section);
      const fetchUrl = `${url}?section_id=${sectionsToUpdate[section]}`;
      return fetch(fetchUrl)
        .then(response => response.text())
        .then(html => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');
          const newSection = doc.querySelector(`#${sectionsToUpdate[section]}`);
          if (newSection) {
            document.querySelector(`#${sectionsToUpdate[section]}`).innerHTML = newSection.innerHTML;
          }
        });
    });

    Promise.all(promises)
      .then(() => {
        window.history.pushState({}, '', url);
        if(collectionTitle){
          document.title = collectionTitle + ' - Novora clothing';
        } 
        document.body.classList.remove('overflow-hidden-mobile');
      })
      .catch(error => {
        console.error('Error fetching section HTML:', error);
      });
  }
}

customElements.define('collection-subcategories', CollectionSubcategories);